// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gqvy","footer":"styles_footer__3DEsx"};